module.exports = __webpack_public_path__ + "static/media/stubbe.19702cfa.mp3";